module.exports = __webpack_public_path__ + "img/pop-up_blog.efec025f.jpg";